// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UndefinedImageTile_wrapper__CoDPS","main":"UndefinedImageTile_main__6_h0K","title":"UndefinedImageTile_title__hqNrh","background":"UndefinedImageTile_background__Zd_p0"};